module.exports = __webpack_public_path__ + "static/media/register-414w.fa4b1f4d.jpg";